import React, { useEffect, useState } from 'react';
import moment from "moment";
import { Link } from 'react-router-dom';
import { collection, getDocs } from "firebase/firestore";
import Footer from './Footer';

export default function AllEvents(props) {

    const [Events, setEvents] = useState([]);

    const [Eventid, setEventid] = useState([])

    const [isLoaded, setIsLoaded] = useState(false);

    async function getData() {
        await getDocs(collection(props.db, "events")).then(element => {
            setEvents(element.docs.map(doc => doc.data()))
            setEventid(element.docs.map(doc => doc.id))
        })
        setIsLoaded(true)
    }

    useEffect(() => {
        getData();
    }, []);

    return (
        isLoaded ?
        <section>
            {console.log(Eventid)}
            <div>
            <div className='py-32 px-8 md:px-16 lg:px-32'>
                <h1 className='text-[7vw] font-bold text-center pb-10'>Events</h1>
                <article className='space-y-12'>
                    {Events.map((element, key) => {
                        return (
                            <div key={element.slug}>
                            <Link to={`/events/${element.slug}`} id={Eventid[key]}>
                                <div className=' bg-[#ed5955] flex flex-col md:flex-row rounded-3xl transition-all duration-200 hover:bg-[#F4DC7C] hover:text-black hover:scale-110'>
                                    <img src={element.image} className='w-full md:w-[35vw] lg:h-80 rounded-t-xl md:rounded-l-3xl' alt={element.title} />
                                    <div className='flex flex-col description py-4'>
                                        <h5 className='text-[3vw] lg:text-[1.5vw] px-4'>
                                            {moment
                                                .unix(element.eventdate.seconds)
                                                .format("MMMM Do YYYY")
                                            }
                                            </h5>
                                        <div className='flex flex-col px-4'>
                                            <h2 className='text-[8vw] md:text-[4vw] font-bold'>{element.title}</h2>
                                            <h4 className='text-[4vw] md:text-[1.5vw]'>{element.description}</h4>
                                        </div>
                                    </div>
                                </div>
                            </Link>
                            </div>
                        )
                    })}
                </article>
            </div>
            </div>
            <Footer />
        </section> : <div className='flex items-center justify-center h-screen'>
            <span className="loader"></span>
        </div>
    );
}